# `root = exports ? this` under Sprockets resolved to `window` (no CommonJS
# exports in the concatenated bundle). Under webpack `exports` is the module's
# exports object, so root.delay / root.isNil / … attached there instead of window
# and pages referencing those helpers as globals broke ("delay is not defined").
# Pin to window to restore the Sprockets global helpers.
root = window

$.fn.extend

  # This method is run on a text input field that should be interpreted as a
  # date/time value. It watches for changes in the field, then sends them to
  # the server to be parsed, and then previewed in the help-block of the
  # control-group for this input field. When the user blurs the text field, the
  # parsed value is then inserted into the text field and the help-block is
  # cleared.
  timeParsedInput: ->

    input = $(this)
    help  = input.closest(".form-field").find(".quick-tip")
    last  = undefined
    error = false
    form  = input.closest("form")
    once  = false

    input.attr("autocomplete", "off")
    help.html(t 'help.time_parser')

    sendParseRequest = ->
      last = input.val()
      once = true
      $.get Routes.parse_time_tools_path(), { str: last }, (data) ->
        if data.error_message
          help.text data.error_message
          error = true
        else
          help.text data.time_pretty
          error = false
        if last == input.val()
          last = undefined
        else
          sendParseRequest()

    applyParseRequest = ->
      return unless once
      if input.val().trim() != "" && help.text() != ""
        input.val(help.text()) if !error
        help.text ""

    input.on "keyup", -> sendParseRequest() unless last?
    form.on "submit", -> applyParseRequest() ; return true

  blink: (duration, period, fn) ->

    e = $(this)

    if duration <= 0
      e.removeClass "blinking"
      fn() if fn?
    else
      if e.hasClass("blinking")
        e.removeClass "blinking"
      else
        e.addClass "blinking"
      duration -= period
      delay period, -> e.blink(duration, period, fn)

    return this

  arrangeable: (rowSelector, thumbSelector) ->

    container = $(this)
    movingElement = null

    container.on "mousedown", thumbSelector, ->
      movingElement = $(this).closest(rowSelector)
      movingElement.addClass("arranging")
      return false

    $(document).on "mousemove", (e) ->
      return true if movingElement == null
      rows = container.find(rowSelector)
      for rowElement in rows.toArray()
        row = $(rowElement)
        middleOfRow = row.offset().top + row.outerHeight()/2
        topOfRow = row.offset().top
        bottomOfRow = row.offset().top + row.outerHeight()
        if e.pageY < middleOfRow
          if rowElement != movingElement[0]
            movingElement.insertBefore(row)
          return false
      movingElement.appendTo(container)
      return false

    $(document).on "mouseup", ->
      return true if movingElement == null
      movingElement.removeClass("arranging")
      movingElement = null
      return false

    return this

  autoFontSize: ->

    $(this).each (i, el) ->
      $this      = $(el)
      fontSize   = parseInt($this.css("font-size"), 10)
      ourText    = $('span:visible:first', this)
      maxHeight  = $this.height()
      maxWidth   = $this.width()
      textHeight = ourText.height()
      textWidth  = ourText.width()

      while (textHeight > maxHeight || textWidth > maxWidth) && fontSize > 3
        fontSize -= 1
        ourText.css("font-size", "#{fontSize}px")
        textHeight = ourText.height()
        textWidth  = ourText.width()

    return this

  autoReload: (path) ->
    AutoRefreshManager.setup($(this), path)
    return this

  customFieldInsertButton: ->
    $(this).each ->
      # Initialize variables
      insertAnchor = $(this)
      inputId      = insertAnchor.closest(".modal").attr("data-input-id")
      textarea     = $("#" + inputId)

      # We need to know where the cursor was to insert the anchor
      textarea.monitorCursor()

      # Listen for the click on the button
      insertAnchor.on "click", ->
        Dialogs.hideAllModals()
        currentValue = textarea.val()
        currentValue = currentValue.replace(/\r\n/g, "\n")
        start = textarea.attr("data-cursor-start")
        fieldName = insertAnchor.attr("data-field-key")
        tag = "%%#{fieldName}%%"
        insertedValue = currentValue.slice(0, start) + tag + currentValue.slice(start)
        textarea.val insertedValue
        return false

  monitorCursor: ->
    input = $(this)
    input.attr "data-cursor-start", 0
    input.attr "data-cursor-end", 0
    input.on "blur", ->
      selection = getInputSelection(this)
      input.attr "data-cursor-start", selection.start
      input.attr "data-cursor-end", selection.end

root.getInputSelection = (el) ->
  start = 0
  end = 0

  if typeof(el.selectionStart) == "number" && typeof(el.selectionEnd) == "number"
    start = el.selectionStart
    end = el.selectionEnd
  else if document.selection && document.selection.createRange
    range = document.selection.createRange()
    if range && range.parentElement() == el
      len = el.value.length
      normalizedValue = el.value.replace(/\r\n/g, "\n")
      textInputRange = el.createTextRange()
      textInputRange.moveToBookmark range.getBookmark()
      endRange = el.createTextRange()
      endRange.collapse false
      if textInputRange.compareEndPoints("StartToEnd", endRange) > -1
        start = end = len
      else
        start = -textInputRange.moveStart("character", -len)
        start += normalizedValue.slice(0, start).split("\n").length - 1

        if textInputRange.compareEndPoints("EndToEnd", endRange) > -1
          end = len
        else
          end = -textInputRange.moveEnd("character", -len)
          end += normalizedValue.slice(0, end).split("\n").length - 1

  return {
    start: start
    end: end
  }

root.insertAtCursor = (field, text) ->
  if document.selection
    field.focus()
    sel = document.selection.createRange()
    sel.text = text
  else
    if field.selectionStart || field.selectionStart == '0'
      startPos = field.selectionStart
      endPos = field.selectionEnd
      field.value = field.value.substring(0, startPos) + text + field.value.substring(endPos, field.value.length)
    else
      field.value += text

# This is to make it nicer to write timeout functions in coffee-script, reversing the arguments.
root.delay = (ms, fn) ->
  setTimeout fn, ms

root.setCheckbox = (el, checked) ->
  if checked
    el.attr("checked", "checked")
  else
    el.removeAttr("checked")

root.setSelectBoxOptions = (box, options, blankOption) ->
  previouslySelectedValue = box.val()
  box.html ""
  box.append($("<option/>").val("").html(blankOption)) if blankOption
  for optionValue, optionLabel of options
    option = $("<option/>").val(optionValue).html(optionLabel)
    option = option.attr("selected", "selected") if optionValue.toString() == previouslySelectedValue
    box.append option
  box.trigger "liszt:updated"

root.rand = (min, max) ->
  min + Math.floor(Math.random() * (max - min + 1))

root.isFlashEnabled = ->
  return true if (typeof navigator.plugins != "undefined" && typeof navigator.plugins["Shockwave Flash"] == "object")
  return true if (window.ActiveXObject && (new ActiveXObject("ShockwaveFlash.ShockwaveFlash")) != false)
  return false

root.encodeHtmlEntities = (html) ->
  html
    .replace(/&/g, '&#38;')
    .replace(/"/g, '&#34;')
    .replace(/'/g, '&#39;')
    .replace(/</g, '&#60;')
    .replace(/>/g, '&#62;')

root.deepCopySimpleObject = (obj) ->
  JSON.parse(JSON.stringify(obj))

root.isNil = (obj) ->
  _.isNull(obj) || _.isUndefined(obj)

root.convertHtmlToText = (html, fn) ->
  $.ajax
    method: "POST"
    url: Routes.convert_html_to_text_tools_path()
    data: { data: html }
    dataType: "html"
    success: (text) => fn(text, null)
    error: (jqXHR, textStatus, errorThrown) => fn(null, errorThrown)
